import React from 'react'
import { MainWrap } from '../../utilities/Shared'
import { useEffect } from 'react'
import axios from 'axios'


const Cust = () => {

    useEffect(() => {

        const getcust = async() => {
      //await axios.get('https://highgroundapi.herokuapp.com/customers/all')
      await axios.get('http://localhost:5001/customers/all')
            .then(res => console.log(res.data))
        }

        getcust()
    },[])
      

  return (
    <MainWrap>Cust</MainWrap>
  )
}

export default Cust